import {defineAsyncComponent} from 'vue';

export const HitDialog = defineAsyncComponent(() => import('./HitDialog.vue'));
export const HitConfirmDialog = defineAsyncComponent(
  () => import('./HitConfirmDialog.vue'),
);
